module.exports = __webpack_public_path__ + "ui-static/img/videos-no-items_light.2b8d8e24.svg";